import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * MongoDB Atlas Leaf Icon
 * Dark green leaf icon representing MongoDB Atlas database
 * Color: #00684A (MongoDB official dark green)
 */
const MongoDBIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        fill="#00684A"
        d="M17.193 9.555c-1.264-5.58-4.252-7.414-4.573-8.115-.28-.394-.53-.954-.735-1.44-.036.495-.055.685-.523 1.184-.723.566-4.438 3.682-4.74 10.02-.282 5.912 4.27 9.435 4.888 9.884l.07.05A73.49 73.49 0 0111.91 24h.481c.114-1.032.284-2.056.51-3.07.417-.296 4.604-3.254 4.292-11.375zm-5.336 7.53l-.5.05c.146 1.174.23 2.353.253 3.534-.884-1.034-1.677-2.153-2.368-3.344.484-.11.983-.165 1.486-.165.382 0 .764.037 1.129.105z"
      />
    </SvgIcon>
  );
};

export default MongoDBIcon;
